<template>
  <div class="content">
    <EstadosDeCuentaTotales></EstadosDeCuentaTotales>

    <EstadosDeCuentaTablas></EstadosDeCuentaTablas>
  </div>
</template>

<script>
import EstadosDeCuentaTotales from "./Index/Totales";
import EstadosDeCuentaTablas from "./Index/Tablas";

export default {
  name: "EstadoDeCuentasIndex",
  components: { EstadosDeCuentaTotales, EstadosDeCuentaTablas },
  beforeMount() {
    this.getCuentas();
  },
  data: () => ({
    isCuentasLoading: true,
  }),
  methods: {
    async getCuentas() {
      this.isCuentasLoading = true;
      await this.$store.dispatch("cuentas/getCuentas");
      this.isCuentasLoading = false;
    },
  },
};
</script>

<style scoped></style>
